<template>
    <UModal
        v-model:open="showHelp"
        title="Hjelp og hurtigtaster"
        :ui="{
            content: 'max-w-7xl'
        }"
    >
        <UButton
            class="menu-item flex items-center cursor-pointer"
            title="Hjelp/Hurtigtaster"
            variant="ghost"
            @click="show()"
        >
            <i class="i-ph-question text-lg"/>
        </UButton>
        <template #body>
            <hotkeys-overview/>
        </template>
        <template #footer>
            Versjon {{ gitVersion }}
        </template>
    </UModal>
</template>

<script setup lang="ts">
import hotkeys from 'hotkeys-js'
import {useToggle} from '@vueuse/core'
import HotkeysOverview from '@/help/HotkeysOverview.vue'
import {gitVersion} from '@/version-checker'

const [showHelp, toggleShowHelp] = useToggle()
const show = () => {
    showHelp.value = true
}

const hide = () => {
    showHelp.value = false
}

hotkeys('f1', () => toggleShowHelp())
hotkeys('*', (event) => {
    if (event.key === '?') {
        show()
    }
})
hotkeys('esc', hide)
</script>

<style scoped>

</style>